export const ERROR_MESSAGES = {
  COMMON: "Error! Please try again later.",
  ZIP_SERVICE_UNAVAILABLE: "Service is not available for the current zip",
  ZIP_PICKUP_UNAVAILABLE: "The pickup request option is not available for the current zip",
  DOWNLOAD: "There was an error downloading the file",
};